import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { Link } from "react-router";

export interface DocumentPreviewLinkProps {
    previewHref?: string;
    onPreviewClick: () => void;
    children: React.ReactNode;
    sx?: SxProps<Theme>;
}

function DocumentPreviewLink({ previewHref, onPreviewClick, children, sx }: DocumentPreviewLinkProps) {
    if (!previewHref) {
        return <>{children}</>;
    }
    return (
        <Box
            component={Link}
            to={previewHref}
            onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                if (e.ctrlKey || e.metaKey || e.shiftKey) {
                    return;
                }
                e.preventDefault();
                onPreviewClick();
            }}
            sx={{ color: "inherit", textDecoration: "none", ...sx }}
        >
            {children}
        </Box>
    );
}

export default DocumentPreviewLink;
